import styled from 'styled-components';

import { WalletType } from '~/shared';

const StyledCard = styled.div`
	flex-shrink: 0;
	position: relative;
	width: 320px;
	padding: 20px;
	border-radius: 10px;
	background: rgba(17, 19, 20, 0.95);
	border: rgba(255, 255, 255, 0.1) 1px solid;
	scroll-margin: 0 56px;
	cursor: pointer;
	transition: background-color 0.25s ease;

	&:hover {
		background: #fff;
	}

	&.selected {
		background: #2d70da;

		.icon {
			opacity: 1;
		}
	}
`;

const StyledVehicleCardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 20px;
	gap: 20px;
`;

const StyledVehicleName = styled.div`
	display: block;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	font-weight: 500;
	line-height: 18px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	color: #fff;
	transition: color 0.25s ease;

	${StyledCard}:hover:not(.selected) & {
		color: #000;
	}
`;

const StyledTagContainer = styled.div`
	display: flex;
	gap: 10px;

	${StyledCard}:hover & .new,
	${StyledCard}.selected & .new {
		color: #fff;
		background-color: #000;
	}
`;

const StyledVehicleSpecs = styled.div`
	position: absolute;
	bottom: 20px;
	width: calc(100% - 40px);
	height: 20px;
	display: flex;
	flex-direction: row;
	transition: filter 0.25s ease;

	${StyledCard}:hover:not(.selected) & {
		> div:first-child {
			color: #000;

			&::before {
				background-color: #000;
			}
		}

		> div:last-child {
			.label {
				color: #000;
			}

			.icon:not(.${WalletType.Donate}) {
				filter: invert(1);
				opacity: 1;
			}
		}
	}
`;

const VehicleCardContainer = styled.div`
	display: flex;
	gap: 20px;
	width: 100%;
	height: 220px;
	overflow-x: auto;
	white-space: nowrap;

	${StyledCard}:first-child {
		margin-left: 60px;
	}

	${StyledCard}:last-child {
		margin-right: 60px;
	}

	&::-webkit-scrollbar {
		display: none;
	}
`;

export {
	StyledCard,
	StyledTagContainer,
	StyledVehicleCardHeader,
	StyledVehicleName,
	StyledVehicleSpecs,
	VehicleCardContainer,
};
